import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { GlobalsVariables } from '../global-Variables';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor( public meta: Meta, public title: Title, private globalVari:GlobalsVariables ) { 
    let site:string="contact";
    this.meta.updateTag({ name: 'description', content: globalVari.meta[site].description }); 
    this.title.setTitle("Chris Wehrmann - "+globalVari.meta[site].title ); 
  }

  ngOnInit() {
    console.log("DRINNN");
  }

}
